import { mountAdyenComponent } from '@/utils/adyen';
import type { UIElement } from '@adyen/adyen-web';
import { useRef, useEffect } from 'react';

interface AdyenComponentContainerProps {
  element: UIElement | null;
}

export const AdyenComponentContainer = ({ element }: AdyenComponentContainerProps) => {
  const container = useRef(null);

  useEffect(() => {
    if (!element) return;

    if (element.isAvailable) {
      element
        .isAvailable()
        .then(() => {
          mountAdyenComponent(element, container.current);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      mountAdyenComponent(element, container.current);
    }

    return () => {
      element.unmount();
    };
  }, [element]);

  return <div ref={container} />;
};
